import { render } from "./FilterConfig.vue?vue&type=template&id=c18a8710"
import script from "./FilterConfig.vue?vue&type=script&lang=js"
export * from "./FilterConfig.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__